import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
    fetchAddAdministrador,
    fetchEditAdministrador,
    fetchGetAdministradorList,
    setFilters,
    returnFetchDeleteAdministrador,
    setLogError,
    setPage,
    setItemsPerPage
} from "../../reducers/administradorSlice";

import {
    AdministradorColumnList,
    AdministradorFilterValidationSchema,
    AdministradorValidationSchema
} from "./AdministradorConstants";
import GenericModule from "../../components/GenericModule";
import Administrador from "./Administrador";



function AdministradorList(props) {

    const moduleData = useSelector((state) => state.administrador);
    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const [selectedAdmin, setSelectedAdmin] = useState();

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const emptyNew = {};;

    useEffect(() => {
        dispatch(fetchGetAdministradorList({ page: 0, pageCount: 0, rowsPerPage: moduleData.itemsPerPage }));
    }, []);

    const refreshData = (filters) => {
        dispatch(fetchGetAdministradorList({ ...filters }));
    }

    const editData = (data) => {
        return Promise.all([
            dispatch(fetchEditAdministrador(data)),
        ]);
    }

    const insertData = (data) => {
        return Promise.all([
            dispatch(fetchAddAdministrador(data)),
        ]);
    }

    const updateFilters = (filters) => {
        dispatch(setFilters(filters));
    }

    const deleteData = async (id) => {
        const response = await returnFetchDeleteAdministrador(id);
        return response;
    }

    const clearLogError = () => {
        dispatch(setLogError(null));
    }

    const handleSetPage = (page) => {
        dispatch(setPage(page));
    }

    const handleSetItemsPerPage = (ipp) => {
        dispatch(setItemsPerPage(ipp));
    }

    const handleFirstClick = (adminId) => {
        setSelectedAdmin(adminId);
        window.$(`#administrador_detail_modal`).modal('show');
    }

    return (
        <>
            <GenericModule
                module={"administrador"}
                validationSchema={AdministradorValidationSchema(t)}
                filterValidationSchema={AdministradorFilterValidationSchema(t)}
                columnList={AdministradorColumnList(logguedUserData.isAdmin)}
                emptyNew={emptyNew}
                setFilters={updateFilters}
                dataList={moduleData.administradorList}
                moduleData={moduleData}
                refreshData={refreshData}
                editData={editData}
                insertData={insertData}
                deleteData={deleteData}
                clearLogError={clearLogError}
                setPage={handleSetPage}
                setItemsPerPage={handleSetItemsPerPage}
                firstItemClick={handleFirstClick}
            />
            <Administrador adminId={selectedAdmin} />
        </>

    );
}

export default AdministradorList;
